export default {
  marketLabel: {
    id: 'buyback_refurbisher_listing_market',
    defaultMessage: 'Market:',
  },
  idLabel: {
    id: 'buyback_refurbisher_listing_uuid',
    defaultMessage: 'Product ID:',
  },
  turnOffline: {
    id: 'buyback_refurbisher_listing_offline_cta',
    defaultMessage: 'Turn offline',
  },
  winAllBackboxes: {
    id: 'buyback_refurbisher_listing_win_all_backboxes',
    defaultMessage: 'Win all backboxes',
  },
  seeDetails: {
    id: 'buyback_refurbisher_listing_see_details',
    defaultMessage: 'See details',
  },
}
